import { CurrencyPipe } from '@angular/common';
import {
  Component,
  effect,
  inject,
  model,
  OnInit,
  signal,
} from '@angular/core';

import { NgIcon, provideIcons } from '@ng-icons/core';
import {
  lucidePenLine,
  lucidePackage,
  lucideTrash2,
} from '@ng-icons/lucide';
import { CrudService } from '../../core/services/crud.service';
import { ProductFormComponent } from '../product-form/product-form.component';
import { DataTableColumn } from '../../shared/components/data-table/data-table.models';
import { DataTableComponent } from '../../shared/components/data-table/data-table.component';

@Component({
  selector: 'app-product-list',
  imports: [NgIcon, ProductFormComponent, DataTableComponent],
  providers: [CurrencyPipe],
  viewProviders: [
    provideIcons({
      lucidePenLine,
      lucidePackage,
      lucideTrash2,
    }),
  ],
  templateUrl: './product-list.component.html',
  styles: ``,
})
export class ProductListComponent implements OnInit {
  private crudService = inject(CrudService);
  private currencyPipe = inject(CurrencyPipe);

  products: Array<any> = [];

  columns: DataTableColumn<any>[] = [
    { key: 'product', label: 'Producto', type: 'custom', sortable: true, sortValue: row => row.name },
    { key: 'sku', label: 'SKU', sortable: true },
    { key: 'categories', label: 'Categorías', type: 'custom' },
    { key: 'price_retail', label: 'Precio <br/>Menudeo', align: 'right', sortable: true, sortValue: row => row.price_retail, renderString: row => this.currencyPipe.transform(row.price_retail, 'MXN') || '', sortType: 'number' },
    { key: 'price_wholesale', label: 'Precio <br/>Mayoreo', align: 'right', sortable: true, sortValue: row => row.price_wholesale, renderString: row => this.currencyPipe.transform(row.price_wholesale, 'MXN') || '', sortType: 'number' },
    { key: 'price_roll', label: 'Precio <br/>por Rollo', align: 'right', sortable: true, sortValue: row => row.price_roll, renderString: row => this.currencyPipe.transform(row.price_roll, 'MXN') || '', sortType: 'number' },
    { key: 'uom', label: 'Unidad <br/>de Medida', align: 'right', sortable: true },
    { key: 'actions', label: 'Acciones', type: 'custom', align: 'center', widthClass: 'w-1/12' }
  ];

  existingProduct: any;

  showModal = model(false);

  constructor() {
    effect(() => {
      if (!this.showModal()) {
        this.getProducts();
      }
    });
  }

  ngOnInit(): void {
    // this.getProducts();
  }

  openModal() {
    this.existingProduct = null;
    this.showModal.set(true);
  }

  getProducts() {
    this.crudService.getProducts().subscribe({
      next: (response: any) => {
        if (response.ok) {
          this.products = response.body;
        }
      },
    });
  }

  updateProduct(product: any) {
    this.existingProduct = product;
    this.showModal.set(true);
  }

  deleteProduct(productId: number) {
    this.crudService.deleteProduct(productId).subscribe({
      next: (response: any) => {
        if (response.ok) {
          // this.getCategories();
          this.getProducts();
        }
      },
    });
  }
}
